import cookie from 'evite.cookie';

function ajax_csrf_setup () {
    let csrfSafeMethod = function(method) {
        return /^(GET|HEAD|OPTIONS|TRACE)$/.test(method);
    };
    let csrf_token = cookie('csrftoken');
    $.ajaxSetup({
        beforeSend: function(xhr, settings) {
            if (!csrfSafeMethod(settings.type)) {
                return xhr.setRequestHeader("X-CSRFToken", csrf_token);
            }
        }
    });
}


export { ajax_csrf_setup };



// WEBPACK FOOTER //
// ./assets/es6/common/ajax_csrf_setup.es6